export const faqs = [
  {
    q: "安装时提示「解析包错误」怎么办？",
    a: "这一般是安装包没有下载完整或文件被占用导致的。请先删除已下载的文件，确认网络稳定后重新下载，再通过文件管理器打开安装包安装。若多次失败，可更换下载时段或网络环境再试。",
  },
  {
    q: "苹果手机提示「未受信任的企业级开发者」？",
    a: "这是苹果对非 App Store 来源应用的正常限制。前往「设置 → 通用 → VPN 与设备管理」，在开发者描述文件里找到对应条目并点击「信任」，返回桌面即可正常打开应用。",
  },
  {
    q: "安装完成后打开就闪退？",
    a: "先确认系统版本是否满足要求，其次检查是否授予了必要的存储与网络权限。若仍闪退，可尝试卸载后清理残留，再重新安装最新版；部分机型需关闭省电模式后再启动。",
  },
  {
    q: "提示「存储空间不足」无法安装？",
    a: "安装包本身加上首次运行的缓存，建议预留 500 MB 以上空间。可在「设置 → 存储」中清理无用的图片、视频与缓存文件，腾出空间后再继续安装。",
  },
  {
    q: "下载速度很慢或中途中断？",
    a: "建议切换到 Wi-Fi 网络后重新下载，并在下载过程中保持屏幕常亮，避免系统休眠中断任务。若使用移动网络，请确认信号稳定且未开启省流量模式。",
  },
  {
    q: "安装后无法联网或视频加载不出来？",
    a: "先检查手机是否授予了应用联网权限，安卓可查看「流量管理 → 应用联网」，苹果可查看是否开启了相关网络限制。关闭后台的省电与流量限制后，重新打开应用即可。",
  },
  {
    q: "更新后需要重新登录吗？",
    a: "同一账号在正常情况下无需重新登录，更新后打开应用即可延续原有状态。若因更换设备或清除数据导致退出，重新输入账号登录即可恢复。",
  },
  {
    q: "一个账号可以在多台设备登录吗？",
    a: "同一账号可在多台设备登录，但为保证账号安全，若检测到异地或异常登录，可能会出现需要重新验证的情况。建议不要将账号借给他人使用。",
  },
];